var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#a0704d;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#eabb8c;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#f9f2d2;mix-blend-mode:overlay;}.cls-6{isolation:isolate;}.cls-7{fill:#bf9162;}.cls-8{opacity:0.57;fill:url(#linear-gradient-3);}.cls-18,.cls-23,.cls-8{mix-blend-mode:hard-light;}.cls-11,.cls-12,.cls-26,.cls-9{fill:none;stroke-miterlimit:10;}.cls-11,.cls-12,.cls-9{stroke:#f90000;}.cls-9{stroke-width:1.06038px;}.cls-10{fill:#f90000;}.cls-11{stroke-width:0.93103px;}.cls-12{stroke-width:0.91797px;}.cls-13{font-size:9.84502px;font-family:Calibri-Bold,\n            Calibri;font-weight:700;}.cls-14{opacity:0.9;}.cls-15{fill:#773507;}.cls-16{clip-path:url(#clip-path);}.cls-17{fill:#e5a87f;}.cls-18{opacity:0.32;}.cls-19{clip-path:url(#clip-path-2);}.cls-20{fill:#e5d78f;}.cls-20,.cls-26{mix-blend-mode:multiply;}.cls-21{clip-path:url(#clip-path-3);}.cls-22{fill:#f2b78f;}.cls-23{opacity:0.49;}.cls-24{clip-path:url(#clip-path-4);}.cls-25{clip-path:url(#clip-path-5);}.cls-26{stroke:#ef9d52;stroke-width:0.27335px;}.cls-27{fill:#763718;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.27998,
    y1: 89.48485,
    x2: 61.77985,
    y2: 89.48485,
    gradientTransform: "translate(-4.83575 4.31679) rotate(-2.26212)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ed9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.27998,
    y1: 80.66051,
    x2: 188.38215,
    y2: 80.66051,
    gradientTransform: "translate(-4.83575 4.31679) rotate(-2.26212)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ed9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02206,
    stopColor: "#f3e598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13311,
    stopColor: "#dabf7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24372,
    stopColor: "#c6a16b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35249,
    stopColor: "#b88c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45853,
    stopColor: "#b07f55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55866,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 61.77985,
    y1: 105.07108,
    x2: 188.38215,
    y2: 105.07108,
    gradientTransform: "translate(-4.83575 4.31679) rotate(-2.26212)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25999,
    stopColor: "#b88956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55363,
    stopColor: "#b07f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88268,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754c29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.686 97.831 12.992 68.519 13.706 86.591 61.4 115.903 60.686 97.831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.686 97.831 12.992 68.519 13.706 86.591 61.4 115.903 60.686 97.831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "187.207 93.271 139.625 64.698 12.992 68.519 60.686 97.831 187.207 93.271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "187.207 93.271 139.625 64.798 12.992 68.519 60.686 97.831 187.207 93.271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "158.382 72.624 22.957 77.973 31.134 85.529 172.529 79.943 158.382 72.624"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "187.904 110.906 61.4 115.903 60.686 97.831 187.207 93.271 187.904 110.906"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "187.904 110.906 61.4 115.903 60.686 97.831 187.207 93.271 187.904 110.906"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 188.92321,
    y1: 120.75959,
    x2: 144.54358,
    y2: 122.78356
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "184.523 117.741 184.985 124.57 190.358 120.76 184.523 117.741"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 63.39198,
    y1: 126.02968,
    x2: 107.79316,
    y2: 124.55199
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "67.54 122.674 67.765 129.236 62.409 126.027 67.54 122.674"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 10.5345,
    y1: 92.68621,
    x2: 26.62902,
    y2: 102.5677
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "15.198 92.236 12.186 97.152 9.816 92.208 15.198 92.236"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 57.38961,
    y1: 121.46747,
    x2: 42.7623,
    y2: 112.30948
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "55.72 117.09 52.656 121.974 58.137 121.898 55.72 117.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 193.02985,
    y1: 94.06947,
    x2: 193.31805,
    y2: 99.5005
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "196.047 97.55 190.28 97.847 193.017 93.232 196.047 97.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 193.74629,
    y1: 109.99857,
    x2: 193.58991,
    y2: 104.60705
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "196.468 106.294 190.696 106.446 193.802 110.834 196.468 106.294"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(114.42148 126.86676) rotate(-2.26212)"
  }, "35 cm"), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(195.71964 104.62292) rotate(-2.26212)"
  }, "5 cm"), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(18.48007 112.58004) rotate(-2.26212)"
  }, "25 cm"), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.20236,112.43148a6.07991,6.07991,0,1,1,5.8352-6.31517A6.08676,6.08676,0,0,1,88.20236,112.43148Zm-.46064-11.66138a5.59056,5.59056,0,1,0,5.80688,5.36553A5.5969,5.5969,0,0,0,87.74172,100.7701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M90.98257,107.24535l.00011-.00015.0392.04733.00973-.00039c.00738-.00029.00628-.02805.0053-.04169a3.109,3.109,0,0,0-6.06942.2314c.00384.03935.055-.00334.055-.00334h0a.5825.5825,0,0,1,.4389-.19294.57418.57418,0,0,1,.46038.16653.06655.06655,0,0,0,.10714-.00423.64926.64926,0,0,1,.90618-.03579.06659.06659,0,0,0,.10718-.00424.64922.64922,0,0,1,.90615-.03579.06659.06659,0,0,0,.10718-.00424.64921.64921,0,0,1,.90614-.03579.0666.0666,0,0,0,.10718-.00423.64926.64926,0,0,1,.90619-.0358.06656.06656,0,0,0,.10714-.00423.57412.57412,0,0,1,.44581-.20233A.58007.58007,0,0,1,90.98257,107.24535Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.86959,110.75939l-.00415.00016h0a.45417.45417,0,0,1-.467-.43557.2447.2447,0,0,1,.4065-.193l-.2087-5.2833a.24467.24467,0,0,1,.489-.01931l.21568,5.46a.45417.45417,0,0,1-.43125.47106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.2815,104.00291a.50779.50779,0,1,1-.74591-.68922,5.66589,5.66589,0,0,1,1.22217-.57445A5.66457,5.66457,0,0,1,87.2815,104.00291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M89.87268,103.39858a.50779.50779,0,0,1-.74592-.68922,5.665,5.665,0,0,1,1.22217-.57445A5.66645,5.66645,0,0,1,89.87268,103.39858Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M91.478,104.986a.50779.50779,0,1,1-.74591-.68922,5.66564,5.66564,0,0,1,1.22216-.57445A5.66609,5.66609,0,0,1,91.478,104.986Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M71.96019,112.80812A6.05868,6.05868,0,1,1,77.775,106.515,6.06551,6.06551,0,0,1,71.96019,112.80812Zm-.459-11.62065a5.571,5.571,0,1,0,5.78661,5.34678A5.57732,5.57732,0,0,0,71.50115,101.18747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M68.07135,107.39183l.53727.49648a.25366.25366,0,0,0,.18315.06749l.77815-.03074.29791-.72135a.17033.17033,0,0,1,.2103-.09688l.0692.02259a.1.1,0,0,0,.11429-.15044l-.58078-.87324a.36789.36789,0,0,0-.35154-.16132l-.94.11647a.1.1,0,0,0-.03556.187.17036.17036,0,0,1,.07733.21082Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M70.26818,108.30106l-1.45949.0829a.67916.67916,0,0,1-.49084-.18088l-.37472-.34627a.59375.59375,0,0,0,.09832.3108l1.05637,1.58819a.59482.59482,0,0,0,.51958.26491l.75187-.0308a.84609.84609,0,1,0-.10109-1.68885Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M72.26356,104.063l-.36786.6864.47086.62238a.17031.17031,0,0,1-.023.23039l-.05453.04822a.1.1,0,0,0,.07176.17475l1.04711-.05814a.36784.36784,0,0,0,.31723-.22127l.376-.86933a.1.1,0,0,0-.14318-.12547.17036.17036,0,0,1-.22092-.04012l-.62211-.78307-.70031.21159A.25341.25341,0,0,0,72.26356,104.063Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M72.29052,103.52913l.48842-.14755a.59375.59375,0,0,0-.31774-.07276l-1.90447.10579a.59484.59484,0,0,0-.49168.31369l-.35446.66378a.84607.84607,0,1,0,1.5071.76875l.66815-1.30022A.67933.67933,0,0,1,72.29052,103.52913Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M73.613,108.27026l-.78033.01159a.17033.17033,0,0,1-.17216-.15481l-.00664-.07252a.1.1,0,0,0-.18334-.04549l-.57241.87877a.36785.36785,0,0,0-.00917.38666l.47868.81728a.1.1,0,0,0,.18585-.04127.17032.17032,0,0,1,.163-.15438l.99933-.03853.24356-.68985a.25353.25353,0,0,0-.01044-.19487Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.5191,107.398l-.32561-.6784a.84608.84608,0,1,0-1.51122.76067l.65331,1.30775a.67918.67918,0,0,1,.02793.52235l-.16987.4811a.59367.59367,0,0,0,.2466-.2132l1.041-1.59826A.59479.59479,0,0,0,75.5191,107.398Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.02813,111.62386a6.02149,6.02149,0,1,1,5.77914-6.2545A6.02834,6.02834,0,0,1,105.02813,111.62386Zm-.45622-11.54933a5.53683,5.53683,0,1,0,5.751,5.314A5.54313,5.54313,0,0,0,104.57191,100.07453Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M106.10106,105.85006l1.99922-.079-.53369-2.26009a.264.264,0,0,0-.26735-.20314l-3.694.14592a.0827.0827,0,0,0-.02156.16152l2.23067.7019a.264.264,0,0,1,.184.23107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M106.64846,103.0402a.7231.7231,0,1,0-.75107-.694A.72311.72311,0,0,0,106.64846,103.0402Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M108.30531,109.24007l-.19889-3.3134-1.98659.07847-1.04026,3.42081a.08271.08271,0,0,0,.14351.076l1.71638-2.1283,1.15661,1.93112A.11274.11274,0,0,0,108.30531,109.24007Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.07733,109.56978l-1.5099.05964a.49129.49129,0,0,1-.50109-.40309l-.64182-3.59864a.48934.48934,0,0,1,.46246-.575l2.50767-.09906a.48943.48943,0,0,1,.5064.53663l-.35595,3.63814A.49143.49143,0,0,1,104.07733,109.56978Zm-2.17122-4.03275-.00448.00554.64182,3.5987.00485.00389,1.5099-.05965.00456-.00433.356-3.638-.00493-.00517Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.06541,109.60979a.24235.24235,0,0,1-.24974-.21212l-.51208-4.09832a.24235.24235,0,0,1,.481-.06009l.512,4.09829a.24233.24233,0,0,1-.21042.27051Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.72026,109.58389c-.00556.00022-.0112.00026-.01689.00011a.24235.24235,0,0,1-.23512-.24934l.121-4.12331a.24233.24233,0,1,1,.48445.0142l-.121,4.12334A.24235.24235,0,0,1,103.72026,109.58389Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.57133,106.71122l-2.72188.10752a.24232.24232,0,0,1-.01913-.48426l2.72188-.10752a.24232.24232,0,1,1,.01913.48426Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.54443,106.02982l-2.72188.10752a.24232.24232,0,0,1-.01913-.48427l2.72188-.10752a.24232.24232,0,1,1,.01913.48427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.47041,107.37538l-2.52393.0997a.243.243,0,0,1-.01913-.48427l2.52393-.0997a.243.243,0,0,1,.01913.48427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.29336,108.25077l-2.13977.08453a.24232.24232,0,1,1-.01913-.48427l2.13977-.08453a.24232.24232,0,0,1,.01913.48427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M102.562,104.34881l1.3817-.342a.08458.08458,0,0,1,.081.141l-.64273.66268a.08462.08462,0,0,1-.10754.01157Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.686 97.831 12.992 68.519 13.706 86.591 61.4 115.903 60.686 97.831"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "28.168 77.767 28.403 87.14 40.487 94.581 40.093 85.175 40.309 78.47 28.168 77.767"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.686 97.831 12.992 68.519 13.706 86.591 61.4 115.903 60.686 97.831"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "28.168 77.767 28.403 87.14 40.487 94.581 40.093 85.175 40.309 78.47 28.168 77.767"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "187.207 93.271 139.625 64.698 12.992 68.519 60.686 97.831 187.207 93.271"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "158.382 72.624 22.957 77.973 31.134 85.529 172.529 79.943 158.382 72.624"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "187.207 93.271 139.625 64.798 12.992 68.519 60.686 97.831 187.207 93.271"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "158.382 72.624 22.957 77.973 31.134 85.529 172.529 79.943 158.382 72.624"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 160.9369,
    y1: 75.67417,
    x2: 32.5863,
    y2: 80.74426
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M175.858,98.08349a4.54389,4.54389,0,1,1-4.01267,4.95613A4.35942,4.35942,0,0,1,175.858,98.08349Zm.05163.52946a4.0157,4.0157,0,1,0,4.20021,3.62073A3.77576,3.77576,0,0,0,175.90964,98.613Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 176.65072,
    y: 106.34224,
    width: 5.34432,
    height: 0.52278,
    transform: "translate(-9.50006 17.90794) rotate(-5.56976)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "182.009 106.893 183.314 106.214 181.903 105.8 182.009 106.893"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M173.11463,107.48338a4.54387,4.54387,0,1,1,4.01267-4.9561A4.35939,4.35939,0,0,1,173.11463,107.48338Zm-.05163-.52939a4.01572,4.01572,0,1,0-4.20021-3.62077A3.77579,3.77579,0,0,0,173.063,106.954Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 166.9776,
    y: 98.70188,
    width: 5.34432,
    height: 0.52277,
    transform: "translate(-8.80418 16.93302) rotate(-5.56976)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "166.963 98.674 165.658 99.352 167.07 99.766 166.963 98.674"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/CD.85faa66895a37759d990b82487313e12.svg";
export { ForwardRef as ReactComponent };